import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da81f2f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    alt: "Foto do produto",
    class: "image",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHover = true)),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHover = false)),
    src: _ctx.renderImage
  }, null, 40, _hoisted_1))
}